module.exports = __webpack_public_path__ + "static/media/paynet.e04a052e.png";